// extracted by mini-css-extract-plugin
module.exports = {"collapseTrigger":"BaseTableCollapseTrigger_collapseTrigger__3mdAI"};